module.exports = __webpack_public_path__ + "assets/img/togny.c40a3a14.png";